// TODO: Move this to get from vendure
export const STAMP_CONFIG = {
  stamps: {
    min: 1,
    max: 15,
    default: 10,
  },
  milestones: {
    maxCount: 5,
    minStamps: 1,
    forceAutoClaim: true, // Force all milestones to be auto-claim
    showAutoClaimOption: false, // Hide the auto-claim checkbox in UI
  },
  validity: {
    minDays: 1,
    maxDays: 3650, // 10 years
    defaultDays: 90,
  },
  maxCardsPerCustomer: {
    min: 1,
    max: 1000,
    default: 1000,
  },
  rules: {
    maxStampingRules: 2,
    maxEligibilityCheckers: 1,
    maxCheckersPerRule: 1,
    showLimitMessage: false, // Set to true to show "Maximum X rules reached" messages
  },
} as const;

export type StampConfigType = typeof STAMP_CONFIG;
